import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconInvite: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="invite, briefing"><path d="M4.75 10.9853V2.75H19.25V10.9853M9.75 7.75H14.25M2.75 10.75V20.25H21.25V10.75L12 13.75L2.75 10.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconInvite;
